var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useRef } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import clsx from 'clsx';
import { Button } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import useCustomTranslation from '@libs/hooks/useCustomTranslation';
/**
 *
 * @description Search Filter for table
 *
 * @param title This is title for page
 * @param listBtns List Buttons: Open modal create; Import, Export excel data; Delete multiple checkbox
 * @param listFilter List Filter: Search, Dates, Selected.
 *
 * @param resolver Check validate for form
 * @param defaultValues Get Defaultvalue for filter
 *
 * @function handleSearch Search the filter to get data for table
 *
 * @returns
 */
var BaseSearchFilter = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Title Page' : _b, listBtns = _a.listBtns, listFilters = _a.listFilters, resolver = _a.resolver, defaultValues = _a.defaultValues, handleSearch = _a.handleSearch;
    var t = useCustomTranslation();
    var formRef = useRef(null);
    var queryClient = useQueryClient();
    var methods = useForm({
        defaultValues: defaultValues,
        resolver: resolver
    });
    // ---------------------------------
    // Effects
    // ---------------------------------
    useEffect(function () {
        if (!formRef)
            return;
        formRef.current.addEventListener('keyup', onKeyUp);
        return function () {
            var _a;
            (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('keyup', onKeyUp);
        };
    }, []);
    // ---------------------------------
    // Functions
    // ---------------------------------
    /**
     * @description Catch keyup event to check enter submit
     *
     * @param e
     */
    function onKeyUp(e) {
        if (e.code === '13') {
            handleSubmit();
        }
    }
    /**
     *
     * @description Submit the data from Form
     *
     * @param data
     */
    var handleSearchFilter = function (data) {
        handleSearch(data);
    };
    /**
     *
     * @description Submit by event
     */
    var handleSubmit = function () {
        if (formRef.current) {
            formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
    };
    var handleReset = function () {
        methods.reset();
        queryClient.clear();
        setTimeout(function () {
            handleSubmit();
        }, 0);
    };
    return (_jsxs("div", { className: 'w-full flex flex-col gap-2', children: [_jsxs("div", { className: 'flex gap-2 justify-between items-center flex-wrap', children: [_jsx("h3", { className: 'text-4xl', children: title }), _jsx("div", { className: 'flex gap-2 flex-wrap items-center max-md:mt-2', children: listBtns &&
                            listBtns.map(function (btn, index) {
                                return _jsx("div", { children: btn }, "btns_".concat(index));
                            }) })] }), listFilters && (_jsx(FormProvider, __assign({}, methods, { children: _jsx("form", { ref: formRef, onSubmit: methods.handleSubmit(handleSearchFilter), children: _jsx("div", { className: clsx('grid grid-cols-1 gap-8', {
                            'sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4': listFilters.length >= 4,
                            'md:grid-cols-2 lg:grid-cols-3': listFilters.length === 3,
                            'md:grid-cols-2': listFilters.length === 2,
                            'md:grid-cols-3 lg:grid-cols-4': listFilters.length === 1
                        }), children: (typeof listFilters === 'function' ? listFilters(methods) : listFilters).map(function (item, index) { return (_jsx("div", { className: 'w-full', children: item }, "filters_".concat(index))); }) }) }) }))), _jsxs("div", { className: 'flex gap-2 mt-4 justify-center pb-4', children: [_jsx(Button, { onClick: handleSubmit, color: 'primary', variant: 'contained', children: t('L000001') }), _jsx(Button, { onClick: handleReset, variant: 'outlined', children: t('L000007') })] })] }));
};
export default memo(BaseSearchFilter);
